import React, { useState } from 'react';
import './SwitchToggle.css';

interface SwitchToggleProps {
  id: string,
  checked: boolean,
  onChange: any,
}

const SwitchToggle = (props: SwitchToggleProps) => {
  const [isChecked, setIsChecked] = useState(props.checked || false);

  const handleChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    if (props.onChange) {
      props.onChange(newValue);
    }
  };

  return (
  <div className="toggle-switch">
    <input
      type="checkbox"
      id={props.id}
      className="toggle-switch-checkbox"
      checked={isChecked}
      onChange={handleChange}
    />
    <label className="toggle-switch-label" htmlFor={props.id}>
      <span className="toggle-switch-inner" />
      <span className="toggle-switch-switch" />
    </label>
  </div>
)}

export default SwitchToggle;